import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { ShowMore } from 'pages/Home/components/ShowMore'
import styles from './CategoryHeader.module.scss'
import CategoryTitle from './CategoryTitle/CategoryTitle'

interface Props {
  title: string
  count: number
  showMoreText: string
  showMoreLink?: string
}

export const CategoryHeader: React.FC<Props> = ({
  title,
  count,
  showMoreText,
  showMoreLink,
}) => {
  return (
    <div className={styles.container}>
      <CategoryTitle title={title} count={count} />
      {showMoreLink && count > 0 && (
        <ShowMore to={showMoreLink}>
          {showMoreText}
          <FontAwesomeIcon icon={faArrowRight} className={styles.arrow} />
        </ShowMore>
      )}
    </div>
  )
}
